// extracted by mini-css-extract-plugin
module.exports = {"checkout":"Checkout_checkout__1WQUQ","checkout__title":"Checkout_checkout__title__2VNm5","checkout__content":"Checkout_checkout__content__3OJYi"};